import React, { useState, useEffect } from "react";
import { Form, Input, Button, Card, Typography, Alert, Divider, Spin, Row, Col } from "antd";
import { UserOutlined, LockOutlined, LoginOutlined, TeamOutlined, CrownOutlined, ShopOutlined, SearchOutlined } from "@ant-design/icons";
import { loginCustomer } from "../../services/customerService";
import "./LoginPage.css";

const { Title, Text, Link } = Typography;

const LoginPage = () => {
  const [form] = Form.useForm();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("userType");
    localStorage.removeItem("userName");
  }, []);

  const handleLogin = async (values) => {
    setError("");
    setLoading(true);

    try {
      const customerLoginRequest = {
        email: values.email,
        password: values.password
      };

      const response = await loginCustomer(customerLoginRequest);

      const { token, refreshToken, id, userType, userName } = response.data;

      localStorage.setItem("token", token);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("userId", id);
      localStorage.setItem("userType", userType);
      localStorage.setItem("userName", userName);

      window.location.href = "/orders";
      
    } catch (error) {
      console.error("Login failed:", error);
      
      if (error.response && error.response.status === 401) {
        setError("Email veya şifre hatalı. Lütfen tekrar deneyiniz.");
      } else {
        setError("Giriş sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.");
      }
    } finally {
      setLoading(false);
    }
  };

  const navigateToLogin = (type) => {
    switch(type) {
      case 'employee':
        window.location.href = '/employee/login';
        break;
      case 'admin':
        window.location.href = '/admin/login';
        break;
      default:
        break;
    }
  };

  const navigateToOrderQuery = () => {
    window.location.href = '/order-query';
  };

  return (
    <div className="login-container">
      <Card className="login-card" bordered={false}>
        <div className="logo-container">
          <img src="/img/icon-512-maskable.png" alt="Siparify" className="company-logo" />
        </div>
        
        <Title level={2} className="login-title">Giriş Yap</Title>
        
        {/* User Type Selection */}
        <div className="user-type-selection" style={{ marginBottom: 24 }}>
          <Text type="secondary" style={{ display: 'block', marginBottom: 12, textAlign: 'center' }}>
            Giriş tipinizi seçin
          </Text>
          <Row gutter={8}>
            <Col span={8}>
              <Button 
                type="default" 
                block 
                icon={<ShopOutlined />}
                style={{ 
                  height: 45,
                  border: '2px solid #1890ff',
                  color: '#1890ff',
                  backgroundColor: '#f0f8ff'
                }}
                disabled
              >
                Şirket
              </Button>
            </Col>
            <Col span={8}>
              <Button 
                type="default" 
                block 
                icon={<TeamOutlined />}
                onClick={() => navigateToLogin('employee')}
                style={{ height: 45 }}
              >
                Çalışan
              </Button>
            </Col>
            <Col span={8}>
              <Button 
                type="default" 
                block 
                icon={<CrownOutlined />}
                onClick={() => navigateToLogin('admin')}
                style={{ height: 45 }}
              >
                Yönetici
              </Button>
            </Col>
          </Row>
        </div>
        
        <Divider plain><Text type="secondary">Şirket Girişi</Text></Divider>
        
        {error && <Alert message={error} type="error" showIcon className="error-alert" />}
        
        <Form
          form={form}
          name="company_login"
          onFinish={handleLogin}
          layout="vertical"
          size="large"
        >
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: "Lütfen email adresinizi giriniz" },
              { type: "email", message: "Geçerli bir email adresi giriniz" }
            ]}
          >
            <Input 
              prefix={<UserOutlined className="site-form-item-icon" />} 
              placeholder="yourname@company.com" 
              disabled={loading}
            />
          </Form.Item>
          
          <Form.Item
            name="password"
            label="Şifre"
            rules={[{ required: true, message: "Lütfen şifrenizi giriniz" }]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              placeholder="Şifrenizi girin"
              disabled={loading}
            />
          </Form.Item>
          
          <Form.Item className="forgot-password-container">
            <Link href="/forgot-password" className="forgot-password-link">
              Şifremi Unuttum
            </Link>
          </Form.Item>
          
          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              className="login-button" 
              block
              icon={loading ? null : <LoginOutlined />}
              disabled={loading}
            >
              {loading ? <Spin size="small" /> : "Şirket Olarak Giriş"}
            </Button>
          </Form.Item>
        </Form>
        
        <Divider plain><Text type="secondary">veya</Text></Divider>
        
        {/* Order Query Button */}
        <Form.Item style={{ marginBottom: 16 }}>
          <Button 
            type="default" 
            block
            icon={<SearchOutlined />}
            onClick={navigateToOrderQuery}
            style={{ 
              height: 48,
              borderColor: '#52c41a',
              color: '#52c41a',
              fontSize: '16px',
              fontWeight: '500'
            }}
          >
            Sipariş Sorgula
          </Button>
        </Form.Item>
        
        <div className="help-text">
          Giriş yapmakta sorun mu yaşıyorsunuz? <Link href="mailto:iletisim@siparify.com">IT Destek</Link> ile iletişime geçin
        </div>
        
        <div className="copyright-footer">
          © 2025 Siparify | All Rights Reserved
        </div>
      </Card>
    </div>
  );
};

export default LoginPage;